import { AxiosResponse } from "axios";
import { ENDPOINTS } from "./endpoints";
import { studioAxiosInstance } from "./instances";
import { IUserDetailResponseData } from "../../redux/reducers/user/userTypes";

export const getUserInformationAPI = async (): Promise<
  AxiosResponse<IUserDetailResponseData>
> => {
  const data = await studioAxiosInstance.get(ENDPOINTS.USER.ME);

  return data;
};
